// Kho toast dùng chung (không phụ thuộc React): baoToast("Đã lưu ✓") gọi được từ bất kỳ đâu; ToastWrap vẽ.
export type LoaiToast = "ok" | "err" | "warn";
export interface MucToast { id: number; text: string; kind: LoaiToast; hien: boolean }

let soId = 0;
let ds: MucToast[] = [];
const nghe = new Set<(d: MucToast[]) => void>();
const phat = () => nghe.forEach((f) => f(ds));

export const layToast = () => ds;
export function ngheToast(f: (d: MucToast[]) => void): () => void {
  nghe.add(f);
  return () => { nghe.delete(f); };
}

/** = toast(text, kind) của app_ops.html: tự ẩn (ok 4 s, lỗi/cảnh báo 7 s), xếp chồng được. */
export function baoToast(text: string, kind: LoaiToast = "ok") {
  const id = ++soId;
  ds = [...ds, { id, text, kind, hien: false }];
  phat();
  requestAnimationFrame(() => { ds = ds.map((t) => (t.id === id ? { ...t, hien: true } : t)); phat(); });
  setTimeout(() => {
    ds = ds.map((t) => (t.id === id ? { ...t, hien: false } : t)); phat();
    setTimeout(() => { ds = ds.filter((t) => t.id !== id); phat(); }, 200);
  }, kind === "ok" ? 4000 : 7000);
}
